import { Validation } from '@hookstate/validation';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import Button from '../../components/Button';
import { useConfigDataState } from '../../globalStates/ConfigDataState';
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState';
import { useLanguageState } from '../../globalStates/LanguageState';
import { useLoadingState } from '../../globalStates/LoadingState';
import { useNotificationsDataState } from '../../globalStates/NotificationDataState';
import { useReferenceDataState } from '../../globalStates/ReferenceDataState';
import FailedValidationModal from './FailedValidationsModal';

const ActionsWrapper = styled.div`
    display: flex;
    & button {
        width: 150px;
        margin: 0 5px;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        text-transform: capitalize;
    }
`

const Actions: React.FC<{}> = (props) => {
    const branding = useLanguageState().getStrings()
    const [modalVisible, setModalVisible] = useState(false)
    const loadingState = useLoadingState()
    const refDataState = useReferenceDataState()
    const exiState = useExhibitorDataState()
    const notifState = useNotificationsDataState()
    const serviceKeys = useConfigDataState().getServiceKeys()
    const publishClickHandler = useCallback(() => {
        const isInvalid = Validation(exiState.getOrganization()).invalid()

        if (isInvalid) {
            // console.log('Validation Errors --- ', Validation(exiState.getOrganization()).errors())
            setModalVisible(true)
        } else {
            loadingState.setActive(true, 'Please wait while publising takes place ...')
            exiState.save(serviceKeys, refDataState)
                .then(() =>
                    notifState.addSuccess("Die Änderungen wurden erfolgreich gespeichert")
                )
                .then(() => {
                    exiState
                        .reinit(serviceKeys)
                        .then(() => {
                            loadingState.setActive(false, '')
                        })
                })
                .catch((error) => {
                    loadingState.setActive(false, '')
                    console.log(error)
                    notifState.addError(error)
                })
        }
    }, [exiState, loadingState, notifState, refDataState, serviceKeys])
    return (
        <ActionsWrapper>
            {modalVisible && <FailedValidationModal visible={modalVisible} onClose={() => { setModalVisible(false) }} />}
            {/* <Button caption={branding.configuration.actionbar.btnPreview} inverse={false} onClick={() => { }} /> */}
            <Button id='publish' caption={branding.configuration.actionbar.btnPublish} inverse onClick={publishClickHandler} />
        </ActionsWrapper>
    );
}

export default Actions;